// types.ts for Collection feature

import { Clip } from '@features/Clip';
import { CollectionMetadata } from '../metadata/types';
import { BaseFeatureArgs } from '@common/types/queryState';

//~ Define your core data model interfaces for this feature
export interface Collection {
    id: string;
    title: string;
    proscopeId: string;

    categoryId: string;
    productionId: string;
    created: string;
    updated: string;
    version: string;

    technicalDetails?: CollectionTechnicalDetails;
}

export interface CollectionTechnicalDetails {
    aspectRatios: string[];
    assetCount: number | string;
    audioLanguages: string[];
    colorSpaces: string[];
    deliverables: string[];
    resolutions: string[];
    stl: boolean;
    volume: number | string;
}

export interface CollectionDetails extends Collection {
    metadata: CollectionMetadata;
    assets: Clip[];
}

interface BackendCustomField {
    label: string;
    value: string;
    type: string;
}

export type BackendCollectionCustomFieldNames =
    | 'aspectRatios'
    | 'assetCount'
    | 'audioLanguages'
    | 'colorSpaces'
    | 'deliverables'
    | 'resolutions'
    | 'stl'
    | 'volume';

export type BackendCollectionCustomFields = Partial<
    Record<
        BackendCollectionCustomFieldNames | (string & {}),
        BackendCustomField
    >
>;

//~ Define Backend response types if they differ significantly from your frontend model
export interface BackendCollection {
    categoryId: number;
    created: number;
    creatorId: number;
    id: number;
    lastUpdated: number;
    modifiedBy: string;
    objectType: string;
    productionId: number;
    title: string;
    version: number;
    customFields?: BackendCollectionCustomFields;
}

//~ Define specific query arguments if not in the API file direclty
export interface GetCollectionsArgs extends BaseFeatureArgs {
    productionId: string;
}

//~ Define the state shape for your Collection feature's local UI state

export const DEFAULT_COLLECTION_TECHNICAL_DETAILS: CollectionTechnicalDetails =
    {
        aspectRatios: [],
        assetCount: 0,
        audioLanguages: [],
        colorSpaces: [],
        deliverables: [],
        resolutions: [],
        stl: false,
        volume: 0,
    };

export const DEFAULT_COLLECTION: Collection = {
    id: '',
    title: '',
    proscopeId: '',
    categoryId: '',
    productionId: '',
    created: '',
    updated: '',
    version: '',
    // technicalDetails: DEFAULT_COLLECTION_TECHNICAL_DETAILS,
};

export interface GetMetricsCollectionArgs {
    productionId: string;
}

export interface MetricDataPoint {
    name: string;
    value: number;
}

export interface MetricsCollection {
    lastAnalysis: string;
    volume: number;
    assetCount: number;

    offerVolume: MetricDataPoint[];
    offerCount: MetricDataPoint[];
    categoryVolume: MetricDataPoint[];
    categoryCount: MetricDataPoint[];
}

export interface GetFavoritesArgs {
    userId: string;
    accountId: string;
    productionId: string;
}

export interface ToggleFavoriteArgs extends GetFavoritesArgs {
    collectionId: string;
    isFavorite: boolean;
}

export interface FavoritesResponse {
    userId: string;
    totalFavorites: number;
    favorites: string[];
}
